export const environment = {
    production: false,
    apiUrl: 'https://gateway.dev.takenote.cloud/flight-centre-au',
    productId: 'TN-FX-Demo',
    productType: 'MGN'
};